import { Menu } from '@unistocks/features/settings/menu';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function MenuScreen() {
  return (
    <>
      <Head>
        <title>{t('::Menu:More')}</title>
      </Head>
      <Menu />
    </>
  );
}
